function state() {
  return {
    privileges: [],
    privilege: {},
    permissions: [],
  };
}

export default state;
